import React from "react";

const Header = () => {
  // const history = useHistory()
  return <header className="header-section">
    <div className="container">
      <h6 className="lato-regular white">Contact Us : <a href="tel:+919941031031" className="lato-regular white">+91 99410 31031</a></h6>
    </div>
  </header>;
}

export default Header;

